import { Pagination } from 'antd';
import './style.scss';
export default function CustomPagination(props) {
	return (
		<>
			<Pagination {...props} />
		</>
	);
}
